import * as yup from 'yup';
import { MAXIMUM_TEXT_AREA_LENGTH } from '@common/types/constants.ts';

export const summaryNotesSchema = yup.object().shape({
  notes: yup
    .string()
    .optional()
    .max(
      MAXIMUM_TEXT_AREA_LENGTH,
      `This input must be ${MAXIMUM_TEXT_AREA_LENGTH} characters or less. Please reduce the length to proceed.`,
    ),
});
